import type { MtbTrailCategory } from "~/lib/api";
import { PillSelector } from "~/components/ui/pill-selector";
import { CATEGORY_LABELS } from "./mtbTrailLabels";

interface MtbTrailCategorySelectorProps {
  value: MtbTrailCategory | null;
  onChange: (value: MtbTrailCategory | null) => void;
}

export function MtbTrailCategoryBadge({ category }: { category: MtbTrailCategory }) {
  const label = CATEGORY_LABELS[category];
  if (!label) return null;

  return <span className="text-sm">{label}</span>;
}

export function MtbTrailCategorySelector({ value, onChange }: MtbTrailCategorySelectorProps) {
  return (
    <PillSelector.Root value={value} onChange={onChange} label="Trail category">
      {Object.entries(CATEGORY_LABELS).map(([category, label]) => (
        <PillSelector.Option key={category} value={category}>
          {label}
        </PillSelector.Option>
      ))}
    </PillSelector.Root>
  );
}
